<template lang="pug">
toggle-button(:value="isChecked", @change="toggleCreative($event, url_token)", :labels="true", :sync="true")
</template>

<script>
export default {
  props: {
    hide_flag: Boolean,
    url_token: String,
    limited_time: Boolean,
    limited_time_range_now: Boolean
  },
  data() {
    return {
      isChecked: true
    };
  },
  created() {
    // 初期値をストアにコミットする
    this.$store.commit('report/updateCreativeReports', { url_token: this.url_token, display: this.hide_flag });
  },
  mounted() {
    this.isChecked = this.limited_time ? this.limited_time_range_now : this.hide_flag;
  },
  methods: {
    async toggleCreative(e, url_token) {

      if (this.limited_time) {
        this.$toasted.error('このクリエイティブは、表示開始・終了予約の設定がされているため、変更できません。クリエイティブ編集ページで、表示開始・終了予約の変更をしてください。')
      } else {
        await this.$store.dispatch("report/toggleCreativeDisplay", { url_token: url_token })
        if (e.value) {
          this.isChecked = true
          this.$toasted.success('配信をONにしました')
          await sleep(10000)
          this.$toasted.clear()
        } else {
          this.isChecked = false
          this.$toasted.success('配信をOFFにしました')
          await sleep(10000)
          this.$toasted.clear()
        }
      }
    },
  }
}
</script>
